import { DocumentType } from "../../types/Documents/DocumentType";
import { PaginationValues } from "../../types/General/PaginationValues";
import api from "../../utils/api";
import { DOCUMENTS_PRIVATE_URL, DOCUMENTS_URL } from "../../utils/endpoints";

export async function getDocuments(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
  isPrivate?: boolean,
) {
  try {
    const response = await api.get(
      id
        ? `${
            isPrivate ? `${DOCUMENTS_PRIVATE_URL}/${id}` : DOCUMENTS_URL
          }/${id}`
        : `${isPrivate ? DOCUMENTS_PRIVATE_URL : DOCUMENTS_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );

    const data: DocumentType[] = id
      ? response.data.name
      : response.data.result.map((option: DocumentType) => ({
          id: option.id,
          name: option.name,
          provinces: option.provinces,
          publishedAt: option.publishedAt ?? null,
          file: option.file,
          authorName: option.authorName,
          subSystems: option.subSystems,
          isPrivate: option.isPrivate,
        }));

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
